import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function WhatSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('what.title')}</h2>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">{t('what.p1')}</p>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">{t('what.p2')}</p>
            <Link
              to="/article/usfans-spreadsheet-guide"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('what.cta')}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-layout-grid-line text-xl" />
              </span>
              <p className="mt-4 text-sm font-semibold text-foreground-900">{t('benefit.1.title')}</p>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{t('benefit.1.desc')}</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6 lg:mt-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-flashlight-line text-xl" />
              </span>
              <p className="mt-4 text-sm font-semibold text-foreground-900">{t('benefit.2.title')}</p>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{t('benefit.2.desc')}</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6 lg:-mt-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-swap-line text-xl" />
              </span>
              <p className="mt-4 text-sm font-semibold text-foreground-900">{t('benefit.3.title')}</p>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{t('benefit.3.desc')}</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-lightbulb-line text-xl" />
              </span>
              <p className="mt-4 text-sm font-semibold text-foreground-900">{t('benefit.4.title')}</p>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{t('benefit.4.desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}